import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryption } from '../../common/enc_dec';
import './videoPlayer.css';
import { addUpdateLessonDetails } from '../../api/apiHandler';

const VideoPlayer = () => {
    const params = useParams(); 
    const { lesson_id, lesson_video, course_id } = decryption(params.data);
    const videoRef = useRef(null);
    const [startTime, setStartTime] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const convertTimeToHHMMSS = (decimalTime) => {
        const totalSeconds = Math.floor(decimalTime); 
        const hours = Math.floor(totalSeconds / 3600); 
        const minutes = Math.floor((totalSeconds % 3600) / 60); 
        const seconds = totalSeconds % 60; 

        
        return [hours, minutes, seconds]
            .map(unit => String(unit).padStart(2, '0')) 
            .join(':');
    };

    const handlePlay = () => {
        setIsPlaying(true);
        const currentTime = videoRef.current.currentTime;
        setStartTime(currentTime);
    };

    const handlePause = () => {
        const currentTime = videoRef.current.currentTime;
        setIsPlaying(false);

        if (startTime !== null && currentTime !== startTime) {
            markLessonAsPaused(lesson_id,currentTime);
        }
    };

    const markLessonAsPaused = async (lessonId,currentTime) => {
        const response = await addUpdateLessonDetails({
            course_id: course_id,
            lession_id: lessonId,
            start_time: convertTimeToHHMMSS(startTime),
            pause_time: convertTimeToHHMMSS(currentTime)
        });
    };

    return (
        <div className="video-player-container">
            <video
                ref={videoRef}
                src={lesson_video}
                controls
                onPlay={handlePlay}
                onPause={handlePause}
                className="video-player"
            />
        </div>
    );
};

export default VideoPlayer;